import { Skeleton } from '@/components/ui';

/**
 * Layout-mirroring placeholder shown inside the KYC dialogs while the Sumsub
 * WebSDK boots — from token mint until the SDK posts `idCheck.onReady`.
 * Roughly mirrors the SDK's first screen: title, instruction lines, step
 * cards, and a CTA — so the swap to the real iframe reads as a fill-in,
 * not a layout jump.
 */
export function KycSdkSkeleton() {
  return (
    <div className="flex flex-col gap-5 py-2" aria-busy="true" aria-live="polite" data-testid="kyc-sdk-skeleton">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-5 w-2/3 rounded" />
        <Skeleton className="h-3 w-full rounded" />
        <Skeleton className="h-3 w-5/6 rounded" />
      </div>
      <div className="flex flex-col gap-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-14 rounded-card" />
        ))}
      </div>
      <Skeleton className="h-[52px] w-full rounded-tab" />
    </div>
  );
}
